import { fflSelectConfigurationSchema } from '@/model/yupSchema.mjs';
import { Button, Input, Text } from '@chakra-ui/react';
import { yupResolver } from '@hookform/resolvers/yup';
import { useEffect } from 'react';
import { SubmitHandler, useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import * as constants from 'utils/constants';
import {
  callToGetFFLSelectConfig,
  callToUpdateSelectConfiguration
} from '../ducks/slice';
import {
  getIsUpdatingSelectConfiguration,
  getFFLSelectConfig
} from './selector';
import { keyType } from '@/queue/types';

function FFLSelectGlobalConfig() {
  const dispatch = useDispatch();
  const isUpdatingSelectConfiguration = getIsUpdatingSelectConfiguration();
  const selectConfig = getFFLSelectConfig();

  const formMapping = [
    {
      label: 'FFL transfer api url',
      inputType: 'text',
      fieldName: 'fflTransferApiUrl'
    },
    {
      label: 'FFL Select url',
      inputType: 'text',
      fieldName: 'selectUrl'
    },
    {
      label: 'FFL Transfer Auth URL',
      inputType: 'text',
      fieldName: 'transferAuthUrl'
    },
    {
      label: 'FFL Store Auth URL',
      inputType: 'text',
      fieldName: 'storeAuthUrl'
    },
    {
      label: 'FFL Select SDK URL',
      inputType: 'text',
      fieldName: 'selectSDKURL'
    }
  ];
  const initialData = {
    fflTransferApiUrl: selectConfig.ffl_transfer_api_url || '',
    selectUrl: selectConfig.ffl_select_url || '',
    transferAuthUrl: selectConfig.transfer_auth_url || '',
    selectSDKURL: selectConfig.ffl_select_sdk_url || '',
    storeAuthUrl: selectConfig.store_config_auth_url || ''
  };

  const {
    handleSubmit,
    register,
    formState: { errors },
    reset
  } = useForm({
    resolver: yupResolver(fflSelectConfigurationSchema),
    mode: 'onChange',
    values: initialData
  });

  enum FormFields {
    fflTransferApiUrl = 'fflTransferApiUrl',
    selectUrl = 'selectUrl',
    transferAuthUrl = 'transferAuthUrl',
    selectSDKURL = 'selectSDKURL',
    storeAuthUrl = 'storeAuthUrl'
  }

  useEffect(() => {
    dispatch(callToGetFFLSelectConfig());
  }, []);

  const submitHandler: SubmitHandler<{
    fflTransferApiUrl?: string | undefined;
    selectUrl?: string | undefined;
    transferAuthUrl?: string | undefined;
    storeAuthUrl?: string | undefined;
    selectSDKURL?: string | undefined;
  }> = (data) => {
    const payload = {
      ffl_transfer_api_url: data.fflTransferApiUrl || "",
      ffl_select_url: data.selectUrl || "",
      ffl_select_sdk_url: data.selectSDKURL || "",
      transfer_auth_url: data.transferAuthUrl || "",
      store_config_auth_url: data.storeAuthUrl || ""
    };
    dispatch(callToUpdateSelectConfiguration(payload));
  };

  const onCancelHandler = () => {
    reset(initialData);
  };

  return (
    <>
      <Text fontSize="30px" as="b">
        {constants.FFL_SELECT_CONFIGURATION}
      </Text>
      <form className="ffl-store-config-form">
        {formMapping.map((formItem) => {
          return (
            <>
              <div className="ffl-store-config-form__form-item">
                <label
                  className="ffl-store-config-form__label"
                  htmlFor={formItem.fieldName}
                >
                  {formItem.label}
                </label>
                <Input
                  className="ffl-store-config-form__input"
                  {...register(formItem.fieldName as FormFields)}
                />
              </div>
              {errors[formItem.fieldName as keyType<typeof errors>] &&
                errors[formItem.fieldName as keyType<typeof errors>]
                  ?.message && (
                  <div className="form-error">
                    {(errors[formItem.fieldName as keyType<typeof errors>]
                      ?.message as string) || ''}
                  </div>
                )}
            </>
          );
        })}
      </form>
      <div className="btn-wrappper">
        <Button
          colorScheme="blue"
          background="#ffffff"
          color="#0C1E46"
          border="1px solid #0C1E46"
          padding="8px 11px"
          marginRight="20px"
          onClick={onCancelHandler}
          isDisabled={isUpdatingSelectConfiguration}
        >
          {constants.CANCEL_TEXT}
        </Button>
        <Button
          colorScheme="blue"
          background="#0C1E46"
          padding="8px 20px"
          onClick={handleSubmit(submitHandler)}
          isLoading={isUpdatingSelectConfiguration}
          isDisabled={isUpdatingSelectConfiguration}
        >
          {constants.SAVE_TEXT}
        </Button>
      </div>
    </>
  );
}

export default FFLSelectGlobalConfig;
